module.exports = __webpack_public_path__ + "img/icon-03-minute.e4f49f31.svg";